import { createContext, useContext, useMemo, useRef } from "react";
import { useQuery, useMutation } from "@tanstack/react-query";
import useToaster from "../../components/alert";
import Const from "../../utils/constant";

import { getHowItWorks, updateHowItWorks } from "../../api/home";

import { getIntialValues, generatePayload } from "./helper";
import { getFaqs } from "../../api/faq";
const PageContext = createContext();

export const PageProvider = ({ children }) => {
  const userImagesArray = useRef();
  const monialsRef = useRef();
  const levelUpsArrayRef = useRef();
  const toaster = useToaster();

  const getHowItWorksQuery = useQuery({
    queryKey: [""],
    queryFn: getHowItWorks,
  });

  const getFaqQuery = useQuery({
    queryKey: [{ limit: 200 }],
    queryFn: getFaqs,
  });
  
  const updateHowItWorksQuery = useMutation({ mutationFn: updateHowItWorks });

  const initialValues = useMemo(() => {
    const homeData = getHowItWorksQuery?.data?.data?.data?.[0] || {};

    return getIntialValues(homeData.page_content);
  }, [getHowItWorksQuery]);

  const handleSubmit = async (values) => {
    const payload = generatePayload(values);
    const homeData = getHowItWorksQuery?.data?.data?.data?.[0] || {};

    updateHowItWorksQuery.mutate(
      { page_content: payload, id: homeData.id },
      {
        onSuccess: () => {
          toaster.success(Const.MESSAGES.SUCCESS, Const.MESSAGES.DATA_IS_UPDATED_SUCCESSFULLY);
          getHowItWorksQuery.refetch();
        },
      },
    );
  };

  const handleUserImagesAdd = () => {
    userImagesArray.current.push({ title: "", description: "", alt_tag: "", desktop_image_url: "" });
  };

  const handleUserImagesDelete = (index) => () => {
    userImagesArray.current.remove(index);
  };

  const handleLevelUpAdd = () => {
    levelUpsArrayRef.current?.push({
      basis: "",
      before: "",
      after: "",
    });
  };

  const handleLevelUpDelete = (index) => () => {
    levelUpsArrayRef.current?.remove(index);
  };

  return (
    <PageContext.Provider
      value={{
        initialValues,
        handleSubmit,
        monialsRef,
        handleUserImagesAdd,
        handleUserImagesDelete,
        userImagesArray,
        levelUpsArrayRef,
        handleLevelUpAdd,
        handleLevelUpDelete,
        getFaqQuery,
      }}
    >
      {children}
    </PageContext.Provider>
  );
};
export const usePageProvider = () => {
  return useContext(PageContext);
};
